export enum PasswordInputTypes {
  PASSWORD = 'password',
  CONFIRM_PASSWORD = 'confirmPassword',
}

export enum PasswordActions {
  CREATE = 'create',
  RESET = 'reset',
}
